import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HeaderComponent } from './dashboard/header/header.component';
import { FooterComponent } from './dashboard/footer/footer.component';
import { LoginSignUpComponent } from './login/login-sign-up/login-sign-up.component';
import { LogoutModalComponent } from './dashboard/header/logout-modal/logout-modal.component';
import { ResetPasswordLayoutComponent } from './login/reset-password-layout/reset-password-layout.component';
import { TokenInterceptorInterceptor } from '../services/authentication/interceptor/token-interceptor.interceptor';
import { LoginForgottenPasswordComponent } from './login/login-forgotten-password/login-forgotten-password.component';
import { ModalOperationCompletedComponent } from './shared/modal-operation-completed/modal-operation-completed.component';
import { SSOCallbackComponent } from './login/ssocallback/ssocallback.component';
import { OktaAuth } from '@okta/okta-auth-js';
import { OktaAuthModule, OktaConfig } from '@okta/okta-angular';
import { environment } from 'src/services/environment';
import { SSOOktaCallbackComponent } from './login/sso-okta-callback/sso-okta-callback.component';

const oktaAuth = new OktaAuth({
  issuer: environment.oktaIssuer,
  clientId: environment.oktaClientId,
  redirectUri: window.location.origin + '/okta/callback',
  scopes: environment.oktaScopes,
  pkce: true,
});
const oktaConfig: OktaConfig = { oktaAuth };

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HeaderComponent,
    FooterComponent,
    SpinnerComponent,
    DashboardComponent,
    LogoutModalComponent,
    LoginSignUpComponent,
    ResetPasswordLayoutComponent,
    ModalOperationCompletedComponent,
    LoginForgottenPasswordComponent,
    SSOCallbackComponent,
    SSOOktaCallbackComponent,
  ],
  imports: [
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    OktaAuthModule.forRoot(oktaConfig),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) =>
          new TranslateHttpLoader(http, './assets/i18n/', '.json'),
        deps: [HttpClient],
      },
    }),
    CommonModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
